
import { defineComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup() {
    const route = useRoute()

    onMounted(() => {
      if (route?.fullPath.includes('wechat_redirect')) {
        // 微信登录
        const code = route?.query?.code
        if (code) {
          window.opener.postMessage(
            {
              type: 'thirdPartyLogin',
              data: {
                code,
              },
            },
            '*',
          )
        } else {
          window.opener.postMessage(
            {
              type: 'thirdPartyLogin',
              data: {
                error: true,
              },
            },
            '*',
          )
        }
        window.close()
      }
    })
    return {}
  },
})
